import React from 'react';

function Settings({ setupData, setSetupData, handleSaveSetup, handleFactoryReset, loading, user, handleLogout }) {
  
  // Your database of known schools. You can easily add more here later!
  const knownSchools = {
    "404624": {
      schoolName: "Larena UCCP Learning Center, Inc.",
      division: "Siquijor",
      district: "Larena",
      address: "Damascus Drive, South Poblacion, Larena, Siquijor"
    }
  };

  // Smart Auto-Fill Logic
  const handleSchoolIdChange = (e) => {
    const newId = e.target.value;
    let updates = { schoolId: newId };

    // If the ID matches a known school, auto-fill the data
    if (knownSchools[newId]) {
      updates = { ...updates, ...knownSchools[newId] };
    }
    
    // Update the state with the new ID and any auto-filled data
    setSetupData({ ...setupData, ...updates });
  };

  const inputStyle = { 
    width: '100%', 
    padding: '10px', 
    fontSize: '15px', 
    borderRadius: '5px', 
    border: '1px solid #aaa', 
    marginBottom: '15px', 
    boxSizing: 'border-box', 
    backgroundColor: '#fff',
    color: '#000'
  };

  const labelStyle = { 
    fontWeight: 'bold', 
    display: 'block', 
    marginBottom: '5px', 
    color: '#333', 
    fontSize: '12px', 
    textTransform: 'uppercase' 
  };

  return (
    <div style={{ padding: '0 15px', display: 'flex', flexDirection: 'column', flex: 1 }}>
      <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', border: '1px solid #ccc', flex: 1, overflowY: 'auto' }}>
        
        {/* --- SCHOOL INFORMATION SECTION --- */}
        <div style={{ marginBottom: '25px', paddingBottom: '20px', borderBottom: '2px dashed #eee' }}>
          <h4 style={{ margin: '0 0 15px 0', color: '#0047a0', fontSize: '16px' }}>School Information</h4>
          
          <div style={{ backgroundColor: '#e8f4f8', padding: '15px', borderRadius: '5px', border: '1px solid #2980b9', marginBottom: '15px' }}>
            <label style={{...labelStyle, color: '#2980b9'}}>Official School ID (Auto-Fills Details)</label>
            <input 
              type="text" 
              style={{...inputStyle, border: '2px solid #2980b9', marginBottom: 0, fontWeight: 'bold'}} 
              value={setupData.schoolId || ''} 
              onChange={handleSchoolIdChange} 
              placeholder="e.g., 404624"
            />
          </div>

          <label style={labelStyle}>Active School Year</label>
          <input 
            type="text" 
            style={inputStyle} 
            value={setupData.schoolYear || ''} 
            onChange={(e) => setSetupData({...setupData, schoolYear: e.target.value})} 
            placeholder="e.g., 2026-2027"
          />

          <label style={labelStyle}>School Name</label>
          <input 
            type="text" 
            style={inputStyle} 
            value={setupData.schoolName || ''} 
            onChange={(e) => setSetupData({...setupData, schoolName: e.target.value})} 
            placeholder="Enter School Name"
          />

          <div style={{ display: 'flex', gap: '10px' }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Division</label>
              <input 
                type="text" 
                style={inputStyle} 
                value={setupData.division || ''} 
                onChange={(e) => setSetupData({...setupData, division: e.target.value})} 
                placeholder="Division"
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>District</label>
              <input 
                type="text" 
                style={inputStyle} 
                value={setupData.district || ''} 
                onChange={(e) => setSetupData({...setupData, district: e.target.value})} 
                placeholder="District"
              />
            </div>
          </div>

          <label style={labelStyle}>School Address</label>
          <input 
            type="text" 
            style={inputStyle} 
            value={setupData.address || ''} 
            onChange={(e) => setSetupData({...setupData, address: e.target.value})} 
            placeholder="Enter full school address"
          />
        </div>

        {/* --- TEACHER INFORMATION SECTION --- */}
        <div style={{ marginBottom: '25px', paddingBottom: '20px', borderBottom: '2px dashed #eee' }}>
          <h4 style={{ margin: '0 0 15px 0', color: '#0047a0', fontSize: '16px' }}>Teacher Information</h4>
          
          <label style={labelStyle}>Teacher's Full Name</label>
          <input 
            type="text" 
            style={inputStyle} 
            value={setupData.teacherName || ''} 
            onChange={(e) => setSetupData({...setupData, teacherName: e.target.value})} 
            placeholder="e.g., Juan Dela Cruz"
          />

          <label style={labelStyle}>Account Email Address</label>
          <input 
            type="email" 
            style={{...inputStyle, backgroundColor: '#f5f5f5', color: '#888'}} 
            value={user.email} 
            readOnly 
            title="This is your login email and cannot be changed here."
          />
        </div>

        {/* --- ACTIONS --- */}
        <button 
          onClick={handleSaveSetup} 
          style={{ width: '100%', padding: '15px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '5px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', marginBottom: '20px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}
        >
          {loading ? "Saving to Cloud..." : "💾 Save Settings to Cloud"}
        </button>

        <div style={{ textAlign: 'center', fontSize: '12px', color: '#666', marginBottom: '20px' }}>
          Logged in as: <strong>{user.email}</strong>
          <br/>
          <button onClick={handleLogout} style={{ marginTop: '10px', padding: '8px 20px', backgroundColor: '#e67e22', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            Secure Logout
          </button>
        </div>

        {/* DANGER ZONE */}
        <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#fdedec', borderRadius: '5px', border: '1px solid #e74c3c' }}>
          <h5 style={{ margin: '0 0 10px 0', color: '#c0392b' }}>Danger Zone</h5>
          <p style={{ fontSize: '11px', color: '#333', marginBottom: '10px' }}>
            Warning: This action will permanently delete all your students, grades, and attendance records from the cloud. This cannot be undone.
          </p>
          <button 
            onClick={handleFactoryReset} 
            style={{ width: '100%', padding: '10px', backgroundColor: 'transparent', color: '#c0392b', border: '2px solid #c0392b', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
          >
            Factory Reset App
          </button>
        </div>

      </div>
    </div>
  );
}

export default Settings;